import { useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import type { IUserData } from '../../../../shared/types';
import { setUserData, unsetUserData, useUserData } from '../../../lib/userData/UserDataProvider';
import { auth } from '../lib/firebase';

export const FirebaseAuthChangeListener = () => {
  const [userData, isLoading] = useUserData();

  useEffect(() => {
    // Give the UserDataProvider time to load the user data from the session cookie
    if (isLoading) return;

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      // console.log(
      //   `%cFirebaseAuthListener: onAuthStateChanged`,
      //   'background:#ffd040; color:#222;',
      //   user ? 'logged in' : 'logged out',
      //   { user }
      // );
      if (process.env.NODE_ENV === 'development') {
        // @ts-expect-error - this is for debugging purposes.
        window.firebase = user;
      }
      if (!user) {
        console.log(
          `%cunsetting userData`,
          'color: #221; background: #F40;padding: 2px 8px; font-weight: bold'
        );
        unsetUserData();
      }
      if (user) {
        if (user.uid !== userData.firebaseUserId) {
          console.log(
            `%c FirebaseAuthChangeListener - posting new token`,
            'background:pink; color:black;',
            { uid: user.uid, firebaseId: userData.firebaseUserId }
          );
          const response = await fetch('/api/token', {
            method: 'POST',
            body: JSON.stringify({ token: await user.getIdToken() }),
          });
          if (response.ok) {
            const data = await response.json();
            // console.log('data', data);
            setUserData(data.userData as IUserData);
          } else {
            console.error('Error signing in:', response.statusText);
          }
        }
      }
    });

    return () => unsubscribe();
  }, [isLoading, userData.firebaseUserId]);

  return null;
};
